type ModifierEvent = {
  ctrlKey?: boolean
  metaKey?: boolean
  shiftKey?: boolean
}

export const isMultiSelectModifierPressed = (
  event: ModifierEvent | null | undefined,
  fallbackIsSelectKeyPressed = false,
) =>
  Boolean(
    event?.shiftKey ||
      event?.ctrlKey ||
      event?.metaKey ||
      fallbackIsSelectKeyPressed,
  )
